<template>
  <CCol col="12">
    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="12" sm="12">
            <CRow>
              <CCol col="12">
                <h2>{{lesson.name}}</h2>
              </CCol>
              <CCol col="12">
                <CLink :to="'/formacao/'+this.$route.params.formacao">
                  <h6>{{lesson.formation}}</h6>
                </CLink>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <p v-html="lesson.content">
                  {{lesson.content}}
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CRow v-if="lesson.exercises.length > 0">
          <CCol md="6">
            <h2 class="aulas">Tarefas</h2>
            <h6>* Após você executar as tarefas o formador irá revisá-las e incluirá um feedback para cada uma.</h6>
          </CCol>
        </CRow>

        <CRow v-for="(ex, i) in lesson.exercises" :key="ex.id" style="padding: 15px;">
          <CCol col="12">
            <h6>{{ex.name}}</h6>
            <p v-html="ex.description"></p>
            <CTextarea
              :disabled="lesson.exercises[i].hasAnswer"
              v-model="lesson.exercises[i].answer"
            >
            </CTextarea>
          </CCol>
          <CCol col="12" style="align-self: flex-end" v-if="!lesson.exercises[i].hasAnswer">
            <CButton color="primary" style="margin-bottom:15px" @click="sendResponse(i)">Enviar Resposta</CButton>
          </CCol>
          <CCol col="12" style="align-self: flex-end" v-if="lesson.exercises[i].reply">
            <p>Retorno do formador:</p>
            <p class="p-3 mb-2 bg-dark text-white">
              {{ lesson.exercises[i].reply }}
            </p>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        <CRow>
          <CCol md="4">
            <CButton class="btn btn-ghost-primary"  @click="goTo('/aula/'+formationId+'/'+prev.id)" :disabled="(prev.id < 0)">
              &#9666; Aula anterior
            </CButton>
          </CCol>
          <CCol md="4" class="text-center" @click="goTo('/formacao/'+formationId)">
            <CButton class="btn btn-pill btn-success">
              Voltar para {{lesson.formation}}
            </CButton>
          </CCol>
          <CCol md="4" class="text-right">
            <CButton class="btn btn-ghost-primary" @click="goTo('/aula/'+formationId+'/'+next.id)" :disabled="(next.id < 0)">
              Próxima aula &#9656;
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
    </CCard>

  </CCol>
</template>

<script>
export default {
  name: 'Formacao',
  components: {

  },
  data () {
    return {
      lesson: {exercises: []},
      prev: {},
      next: {},
      formationId: 0
    }
  },
  mounted() {
    this.formationId = this.$route.params.formacao
    this.getLesson();
  },
  methods: {

    goTo(path) {
      this.$router.push({'path': path})
    },

    getLesson  () {
      this.$loading(true)
      this.$http.get('api/lessonsUser/'+this.$route.params.formacao+'/'+this.$route.params.aula)
      .then(res => {
        if (res.status === 200)
        {
          this.lesson = res.data.lesson
          this.prev = (res.data.prev !== null) 
                    ? res.data.prev
                    : {id:-1} 
          this.next = (res.data.next !== null)
                    ? res.data.next
                    : {id:-1}
          
          if (this.lesson.exercises === undefined) {
            this.lesson.exercises = []
          }

          for (let i = 0; i < this.lesson.exercises.length; i++) {
            if (this.lesson.exercises[i].answer === null) {
              this.lesson.exercises[i].hasAnswer = false
            } else {
              this.lesson.exercises[i].hasAnswer = true
              this.lesson.exercises[i].reply = this.lesson.exercises[i].answer.replay
              this.lesson.exercises[i].answer = this.lesson.exercises[i].answer.answer
            }
          }
          this.$loading(false)
        }
      })
      .catch(error => {
        this.$loading(false)
      });
    },

    sendResponse(i) {
      this.$loading(true)
      this.$http.post('api/exercises/answer',
      {
        exercise: this.lesson.exercises[i]
      }).then(res => {
        if (res.status === 200)
        {
          if (res.data.code === 0)
          {
            this.$swal({
              icon: 'success',
              title: 'Resposta enviada com sucesso!',              
            }).then(() => { 
              this.getLesson();
            })
          }
        } else {
          this.formErrors = res.data.errors
        }
        this.$loading(false)
      })
      .catch(error => {
        this.$loading(false)
      });
    }
  },
  watch: {
    '$route': 'getLesson'
  }
}
</script>
<style scoped>
.card-body{
  padding:50px;
}
@media (max-width: 575px) {
  .card-body{
    padding:25px;
  }
}
p.description{
  margin-top:25px;
}
.card-body h2{
  color: #03033d;
}
.card-body h6{
  color: #9ca1a8;
  margin-bottom: 20px;
}
.card-body .aulas{
  margin-bottom: 20px;
}
.lesson-disabled {
  padding-top: 5px;
  font-size: 16px;
}
.lessons-list{
  margin-bottom: 50px;
}
.call-to-formation {
  padding: 25px;
}
.call-to-formation p{
  color: black;
  font-weight: 500;
}
.formation-link {
  background-color: #ececec;
  margin-bottom: 15px;
  cursor: pointer;
}
</style>
<style>
.card-body figure.media > div{
  flex: 0 0 50%;
  margin: auto;
}
@media (max-width: 575px) {
  .card-body{
    padding:25px;
  }
  .container-fluid {
    padding-left:0;
    padding-right:0;
  }
  .card-body figure.media > div{
    flex: 0 0 100%;
    margin: auto;
  }
}
</style>
